export const formatPercent = (
  percentage?: string,
  locale: string = 'en-US',
): string =>
  percentage
    ? new Intl.NumberFormat(locale, { style: 'percent' }).format(
        parseFloat(percentage),
      )
    : '';
